import { FilterTabOption } from 'components/CruiseSearchWidget/types';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { useState } from 'react';

export const useTabs = () => {
	const { activeFilter } = useFiltersContext();

	const tabsOptions = activeFilter?.tabs;
	const defaultTab: FilterTabOption | undefined = tabsOptions?.[0];
	const [activeTab, setActiveTab] = useState<FilterTabOption | undefined>(defaultTab);

	return { tabsOptions, defaultTab, activeTab, setActiveTab };
};
